import { Box, FormControlLabel, Paper, Radio } from "@mui/material";
import Text from "../ui/Text";

const RadioButtonOption = ({
  value,
  selectedValue,
  icon,
  title,
  description,
  onClick,
}) => {
  const isSelected = selectedValue === value;

  return (
    <Paper
      sx={{
        p: "10px 8px",
        border: isSelected
          ? "1px solid #1890FF !important"
          : "1px solid #D4D4D4",
        borderRadius: "4px",
        cursor: "pointer",
        boxShadow: "none",
      }}
      onClick={() => onClick && onClick(value)}
    >
      <FormControlLabel
        sx={{ display: "flex", alignItems: "start" }}
        value={value}
        control={<Radio />}
        label={
          <Box>
            <Text
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              {icon}
              {title}
            </Text>
            <Text variant="paragraph3" sx={{ color: "#000" }}>
              {description}
            </Text>
          </Box>
        }
      />
    </Paper>
  );
};

export default RadioButtonOption;
